<template>
  <div
    class="accruals-condition-connector"
    :data-testid="dataTestid"
  >
    <div class="accruals-condition-connector__rail">
      <span class="accruals-condition-connector__line" aria-hidden="true" />
      <button
        v-if="editable"
        type="button"
        class="accruals-condition-connector__badge"
        :class="badgeClass"
        :data-testid="`${dataTestid}__toggle`"
        :aria-label="`Toggle connector to ${nextConnectorLabel}`"
        @click="toggleConnector"
      >
        <span class="accruals-condition-connector__label">{{ connectorLabel }}</span>
        <span class="accruals-condition-connector__chevrons" aria-hidden="true">
          <v-icon x-small>mdi-chevron-up</v-icon>
          <v-icon x-small>mdi-chevron-down</v-icon>
        </span>
      </button>
      <span
        v-else
        class="accruals-condition-connector__badge"
        :class="badgeClass"
        :data-testid="`${dataTestid}__label`"
      >
        <span class="accruals-condition-connector__label">{{ connectorLabel }}</span>
        <span class="accruals-condition-connector__chevrons" aria-hidden="true">
          <v-icon x-small>mdi-chevron-up</v-icon>
          <v-icon x-small>mdi-chevron-down</v-icon>
        </span>
      </span>
      <span class="accruals-condition-connector__line" aria-hidden="true" />
    </div>
  </div>
</template>

<script>
import { LOGICAL_CONNECTORS } from '../accrualsRulesBuilderUtils';

export default {
  name: 'AccrualsConditionConnector',
  props: {
    value: { type: String, default: LOGICAL_CONNECTORS.AND },
    editable: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'accruals-condition-connector' },
  },
  computed: {
    connectorLabel() {
      return String(this.value || LOGICAL_CONNECTORS.AND).toUpperCase();
    },
    nextConnectorLabel() {
      return this.value === LOGICAL_CONNECTORS.OR
        ? LOGICAL_CONNECTORS.AND.toUpperCase()
        : LOGICAL_CONNECTORS.OR.toUpperCase();
    },
    badgeClass() {
      return this.value === LOGICAL_CONNECTORS.OR
        ? 'accruals-condition-connector__badge--or'
        : 'accruals-condition-connector__badge--and';
    },
  },
  methods: {
    toggleConnector() {
      if (!this.editable) return;
      const next =
        this.value === LOGICAL_CONNECTORS.OR
          ? LOGICAL_CONNECTORS.AND
          : LOGICAL_CONNECTORS.OR;
      this.$emit('input', next);
      this.$emit('change', next);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsConditionConnector.scss';
</style>
